import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'
import { validators } from '@blazar/tracking'
import gtm from '@blazar/tracking-google-tagmanager'

import * as accountActions from 'reduxBits/account/actions'
import * as analyticsActions from 'reduxBits/analytics/actions'
import * as classifiedActions from 'reduxBits/classified/actions'

import { renderDataLayerObject } from 'tracking/dataLayerUtils'
import { errorTypes } from 'reduxBits/account'

const createDataLayerObject = (state, localData = {}) =>
  renderDataLayerObject({
    // No globals needed
    ...{
      objectCustom: undefined,
      event: 'event',
      objectType: 'UIElement',
      domain: 'adout',
    },
    ...localData,
  })

export const saveAdwatch = {
  validators: [validators.redux(accountActions.RECEIVE_CREATE_AD_WATCH)],
  events: [
    gtm.event(({ state }) => {
      const hasReachedAdWatchLimit =
        _.get(state, ['account', 'adWatches', 'errorType']) === errorTypes.MAX_ADWATCHES_ERROR
      return createDataLayerObject(state, {
        // objectId, Will be path at the gtm side
        eventType: 'Save',
        eventCategory: 'search',
        eventAction: 'watched search',
        objectName: 'Save ad watch',
        objectType: 'Listing',
        ...(hasReachedAdWatchLimit && {
          objectType: 'Error',
          eventType: 'Engagement',
          eventAction: 'too many ad watches',
          objectName: 'Error ad watch',
          objectCause: [{ definition: errorTypes.MAX_ADWATCHES_ERROR }],
        }),
      })
    }),
  ],
}

export const unsaveAdWatch = {
  validators: [validators.redux(accountActions.RECEIVE_DELETE_AD_WATCH)],
  events: [
    gtm.event(({ state }) =>
      createDataLayerObject(state, {
        // objectId, Will be path at the gtm side
        eventType: 'Unsave',
        eventCategory: 'search',
        eventAction: 'unwatched search',
        objectName: 'Unsave ad watch',
        objectType: 'Listing',
      }),
    ),
  ],
}

export const adClicked = {
  validators: [
    validators.redux(classifiedActions.AD_CLICKED, () => true, ({ payload }) => payload),
  ],
  events: [
    gtm.event(({ state, accumulator }) => {
      const adId = _.get(accumulator, 'adId') || undefined
      const pageLimit = _.get(state, 'classified.searchResults.query.lim', 40)
      const pageIndex = _.get(state, 'classified.searchResults.query.page', 0)
      const clickedAdIndex = _.findIndex(
        _.get(state, 'classified.searchResults.ads'),
        (o) => o.adId === adId,
      )
      const adRank = pageIndex * pageLimit + clickedAdIndex

      return createDataLayerObject(state, {
        objectId: 'ad_clicked',
        objectName: 'Ad clicked',
        eventType: 'Engagement',
        eventCategory: 'search',
        eventAction: 'clicked ad',
        objectListIndex: adRank,
        target: {
          id: adId,
          type: 'ClassifiedAd',
          name: '',
          category: ' ',
        },
        search: {
          '@id': uuidv4(),
          '@type': 'SearchMetadata',
          rank: adRank,
        },
      })
    }),
  ],
}

export const trackFooterNavigation = {
  validators: [
    validators.redux(
      analyticsActions.TRIGGER_FOOTER_NAV_ANALYTICS,
      () => true,
      ({ payload }) => payload,
    ),
  ],
  events: [
    gtm.event(({ state, accumulator }) =>
      createDataLayerObject(state, {
        objectId: 'footer-navigation',
        objectName: accumulator,
        eventType: 'Engagement',
        eventCategory: 'navigation',
        eventLabel: accumulator,
        eventAction: 'clicked on footer navigation',
        origin: {
          id: document.location.pathname + document.location.search,
          url: encodeURI(window.location.href),
        },
      }),
    ),
  ],
}
